import React, { Component } from 'react'
import Loadable from 'react-loadable'
import Loading from './components/loading/Loading'
import './App.css'
import gtagUA from './gtag-ua.js'

import {
  // BrowserRouter as Router,
  Router,
  Route,
  Switch
} from 'react-router-dom'

import createBrowserHistory from 'history/createBrowserHistory'

import Nav from './components/nav/Nav'
// import Section from './components/section/Section'
// import About from './components/about/About'
// import Experience from './components/experience/Experience'
// import Education from './components/education/Education'
// import Skills from './components/skills/Skills'
// import Portfolio from './components/portfolio/Portfolio'
// import Publications from './components/publications/Publications'
// import Contact from './components/contact/Contact'
import NotFound from './components/404/404'

const LoadableAbout = Loadable({loader: () => import('./components/about/About'), loading: Loading})
// const LoadableExperience = Loadable({loader: () => import('./components/experience/Experience'), loading: Loading})
// const LoadableEducation = Loadable({loader: () => import('./components/education/Education'), loading: Loading})
// const LoadableSkills = Loadable({loader: () => import('./components/skills/Skills'), loading: Loading})
// const LoadablePortfolio = Loadable({loader: () => import('./components/portfolio/Portfolio'), loading: Loading})
const LoadablePublications = Loadable({loader: () => import('./components/publications/Publications'), loading: Loading})
// const LoadableContact = Loadable({loader: () => import('./components/contact/Contact'), loading: Loading})

// const AboutSection = Section(About)

// GOOGLE ANALYTICS PAGEVIEWS
const history = createBrowserHistory()

history.listen(location => {
  // if (window.ga) {
  //   console.log(`Sending pageview to '${location.pathname}' on location change`)
  //   window.ga('send', 'pageview', location.pathname)
  // }
  if (window.gtag) {
    console.log(`Sending pageview to '${location.pathname}' on location change`)
    window.gtag('config', gtagUA, {
      path_path: location.pathname
    })
  }
})

class App extends Component<{}> {

  componentDidMount () {

    setTimeout(() => {
      LoadableAbout.preload(),
      // LoadableExperience.preload()
      // LoadableEducation.preload()
      // LoadableSkills.preload()
      // LoadablePortfolio.preload()
      LoadablePublications.preload()
      // LoadableContact.preload()
    }, 1000)

  }

  render () {
    return (
      <Router history={history}>
        <div> {/* className='App' */}

          <Nav />

          <div className='container-fluid p-0'>
            <section className='resume-section p-3 p-lg-5 d-flex d-column'>
              <div className='my-auto w-100'>
                <Switch>
                  <Route exact path='/' component={LoadableAbout} />
                  {/* <Route exact path='/experience' component={LoadableExperience} />
                  <Route exact path='/education' component={LoadableEducation} />
                  <Route exact path='/skills' component={LoadableSkills} />
                  <Route exact path='/portfolio' component={LoadablePortfolio} />
                  */}
                  <Route exact path='/publications' component={LoadablePublications} />
                  {/*
                  <Route exact path='/contact' component={LoadableContact} />*/}
                  <Route component={NotFound} />
                </Switch>
              </div>
            </section>
          </div>

        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js